// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperImages-cls1_K-8","cls2":"PaperImages-cls2_va8 PaperImages-cls1_K-8"};